"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionValue = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _SessionStorage = require("./SessionStorage");
var SessionValue = function SessionValue(key) {
    var _this = this;
    _class_call_check(this, SessionValue);
    (0, _defineProperty2.default)(this, "key", void 0);
    (0, _defineProperty2.default)(this, "storage", new _SessionStorage.SessionStorage());
    (0, _defineProperty2.default)(this, "remove", function() {
        _this.storage.removeItem(_this.key);
        return _this;
    });
    (0, _defineProperty2.default)(this, "get", function() {
        return _this.storage.getItem(_this.key);
    });
    (0, _defineProperty2.default)(this, "set", function(value) {
        _this.storage.setItem(_this.key, value);
        return _this;
    });
    this.key = key;
};
exports.SessionValue = SessionValue; //# sourceMappingURL=SessionValue.js.map
